<template>
  <div class="container mx-auto">



    <h5 class="d-inline-block" v-if="user">شارژ کیف پول:

      {{ `${user.name} ${user.last_name}` }}

      (
      موجودی:
      {{ formatNumber(walletValue(user.wallet)) }}
      )

    </h5>
    <history-wallet class="d-inline-block mx-3" :user_id="user.id"/>

    <b-col lg="5" cols="12" class="mx-auto">
      <b-form @submit.prevent="onSubmit">

        <form-group class="my-3" :validations="$v.form.value">
          <div slot-scope="{ errors, invalid }">
            <div class="form-group">
              <label>مقدار</label>
              <b-form-input class="text-left" dir="ltr" v-model="form.value" :class="{invalid}"/>
              <form-errors-manager :errors="errors"/>
            </div>

          </div>
        </form-group>


        <form-group class="my-3" v-if="isAdmin" :validations="$v.form.transactionType">
          <div slot-scope="{ errors, invalid }">
            <div class="form-group">

              <b-form-group label="نوع عملیات">
                <b-form-radio class="d-inline-block mx-3" v-model="form.transactionType" name="" value="1">شارژ
                </b-form-radio>
                <b-form-radio class="d-inline-block mx-3" v-model="form.transactionType" name="" value="0">بدهی
                </b-form-radio>
              </b-form-group>


              <form-errors-manager :errors="errors"/>
            </div>

          </div>
        </form-group>

        <form-group class="my-3" v-if="isAdmin" :validations="$v.form.description">
          <div slot-scope="{ errors, invalid }">
            <div class="form-group">
              <label>توضیحات</label>
              <b-form-textarea v-model="form.description"/>
              <form-errors-manager :errors="errors"/>
            </div>

          </div>
        </form-group>


        <div v-if="!isAdmin" class="my-3 py-3 bg-light">
          <h4>درگاه پرداخت</h4>

          <form-group class="my-3" :validations="$v.form.gateway">
            <div slot-scope="{ errors, invalid }">
              <b-form-group>

                <b-form-radio class="d-inline mx-2" v-if="checkMellatGate" v-model="form.gateway"
                              value="mellat"
                              name="payment-method">ملت
                </b-form-radio>
                <b-form-radio class="d-inline mx-2" v-if="checkZarinpalGate" v-model="form.gateway"
                              value="zarinpal"
                              name="payment-method">زرین پال
                </b-form-radio>
                <form-errors-manager :errors="errors"/>

              </b-form-group>
            </div>
          </form-group>

        </div>


        <div class="mx-auto text-center">
          <b-btn pill type="submit" class="w-50 ">ثبت</b-btn>
        </div>


      </b-form>
    </b-col>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {required, numeric} from "vuelidate/lib/validators";
import FormGroup from "../../validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import {formatNumber, walletValue} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import HistoryWallet from "./HistoryWallet";


export default {
  name: "ChargeWallet",
  components: {
    FormGroup,
    FormErrorsManager,
    HistoryWallet,
  },
  data() {
    return {
      form: {
        value: '',
        description: '',
        transactionType: '',
        user_id: this.$route.params.user,
        gateway: '',
      },
      user: {}
    }
  },
  validations() {
    if (this.isAdmin) {
      return {
        form: {
          value: {required, numeric},
          description: {required},
          transactionType: {required}
        },
      }
    } else {
      return {
        form: {
          value: {required, numeric},
          gateway: {required}
        },
      }
    }
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    async onSubmit() {
      if (this.invalid()) {
        if (this.isAdmin && confirm('از شارژ کردن اعتبار کاربر اطمینان دارید؟')) {

          let form = Object.assign({}, this.form);

          if (this.form.transactionType == 0) {
            form.value *= -1;
          }
          await this.$store.dispatch('Wallet/adminChargeWallet', form)
          await this.getUserInformation()
        } else { // user
          await this.$store.dispatch('Wallet/userChargeWallet', this.form)
        }
      }
    },
    formatNumber,
    walletValue,
    getUserInformation() {
      this.$store.dispatch('User/getUserWithoutState', this.form).then(res => {
        this.user = res.data.data;
      })
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: "User/isAdmin"
    }),
    checkZarinpalGate() {
      return this.findAttributeOnSiteInfo('zarinpal_merchant_id')[0] !== '';
    },
    checkMellatGate() {
      return this.findAttributeOnSiteInfo('mellat_gate_info')[0] !== '';
    },
  },
  mounted() {
    this.getUserInformation();
  },
  watch: {
    '$route'(to, from) {

      this.form.user_id = this.$route.params.user
      this.getUserInformation();

    }
  }
}
</script>

<style scoped>

</style>